<template>
  <div @click.stop="setStar" :class="[starStyle, { active: getBoolean(isSelect) }]">
    <i class="icon" :class="{ 'el-icon-star-off': starStyle === 'iconstar3'}"></i>
    <span v-if="starStyle === 'iconstar3'" class="sp1">我感兴趣</span>
    <span v-if="showzero" class="desc">{{ getNumber(count) }}</span>
    <span v-if="!showzero && count !== 0" class="desc">{{ count }}</span>
  </div>
</template>

<script>
import { isLogin } from '@/utils/index'
import { setupdateStar } from '@/api/datavolume/index'
export default {
  name: 'star',
  props: ['starStyle', 'isSelect', 'count', 'menuId', 'businessId', 'showzero', 'title', 'image', 'url'],
  data () {
    return {
      /* 更新后数据 */
      starupdateObj: {
        count: 0,
        isSelect: false,
        id: ''
      }
    }
  },
  methods: {
    getNumber (val) {
      if (val !== undefined) {
        return val
      } else {
        return 0
      }
    },
    getBoolean (val) {
      if (val === 'false') {
        return false
      } else if (val === 'true') {
        return true
      } else {
        return val
      }
    },
    setStar () {
      let type = ''
      if (this.$route.name.indexOf('information') > -1) type = 'infor'
      if (this.$route.name.indexOf('live') > -1) type = 'live'
      if (this.$route.name.indexOf('travelguide') > -1) type = 'guice'
      if (this.$route.name.indexOf('delicacy') > -1) type = 'delicary'
      if (this.$route.name.indexOf('homestayhotel') > -1) type = 'homestayHotel'
      if (this.$route.name.indexOf('scenicspotdetail') > -1) type = 'scenicspot'
      let param = {
        'menuId': this.menuId,
        'businessId': this.businessId,
        'fid': this.$cookie.get('culturalCloud_fid'),
        'webUserId': this.$cookie.get('wlymobilephone'),
        'title': this.title,
        'image': this.image,
        'url': this.url
      }
      if (type !== '') param.type = type
      if (this.getBoolean(this.isSelect)) {
        this.$confirm('确定取消点赞？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          setupdateStar(JSON.stringify(param)).then((res) => {
            if (res.data.status === 200) {
              this.starupdateObj.count = this.count - 1
              this.starupdateObj.isSelect = false
              this.starupdateObj.id = this.businessId
              this.$message({ message: '取消点赞成功', type: 'success' })
              this.$emit('changecount', this.starupdateObj)
            } else {
              isLogin(res.data.message)
            }
          })
        }).catch(() => { })
      } else {
        setupdateStar(JSON.stringify(param)).then((res) => {
          if (res.data.status === 200) {
            this.starupdateObj.count = this.count + 1
            this.starupdateObj.isSelect = true
            this.starupdateObj.id = this.businessId
            this.$message({ message: '点赞成功', type: 'success' })
            this.$emit('changecount', this.starupdateObj)
          } else {
            isLogin(res.data.message)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.iconstar1{
  display: inline-block;
  line-height: 32px;
  .icon{
    display: inline-block;
    width: 32px;
    height: 32px;
    background: url('../../assets/common/icon/icon-group2.png') no-repeat;
    background-position: -96px 0;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }
  .desc{
    display: inline-block;
  }
  &.active,
  &:hover{
    .icon{
      background-position: -64px 0;
    }
    .desc{
      color: #00c868;
    }
  }
}
.iconstar2{
  display: inline-block;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
  cursor: pointer;
  margin: 0 0 6px 0;
  transition: all 0.3s;
  position: relative;
  .icon{
    display: block;
    margin: 6px auto;
    width: 32px;
    height: 32px;
    background: url('../../assets/common/icon/icon-group2.png') no-repeat;
    background-position: 0px -32px;
    vertical-align: middle;
  }
  .desc{
    display: block;
    position: absolute;
    height: 14px;
    line-height: 14px;
    border-radius: 6px;
    padding: 0 4px;
    background: #b2bac2;
    color: #fff;
    left: 30px;
    top: -2px;
    font-size: 12px;
  }
  &.active,
  &:hover{
    .icon{
      background-position: -64px 0px;
    }
    .desc{
      background: #0da78f;
      color: #fff;
    }
  }
}
.iconstar3{
  border-radius: 30px;
  padding: 10px 22px 10px 18px;
  display: inline-block;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin: 20px 0 0;
  text-align: center;
  cursor: pointer;
  .sp1{
    margin: 0 10px 0 8px;
  }
  &.active,
  &:hover{
    transition: all 0.3s;
    background-color: #f56c6c;
    border-color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/amount/star.vue